src/components/BkLine.vue

<template>
  <span>{{ lineStr }}</span>
</template>

<script>
export default {
  name: "BkLine",
  props: ['market', 'target', 'pivot'],
  data() {
    return {
      market_map: {
        'TOTAL': 'Total',
        'T1_TOTAL': 'Total1',
        'T2_TOTAL': 'Total2',
        'CORNER_TOTAL': '(Corners) Total',
        'YC_TOTAL': '(Bookings) Total',
        'ONE_TWO': '1X2',
        'HDP': 'Handicap',
        'CORNER_HDP': '(Corners) Hand',
        'YC_HDP': '(Bookings) Hand',
        'EURO_HDP': 'Hand',
        'OUT_TOTAL': '(Outs) Total',
      },
      target_map: {
        'OVER': 'Over ',
        'UNDER': 'Under ',
        'ONE': ' Win1 ',
        'TWO': ' Win2 ',
        'DRAW': ' X ',
        'ONE_DRAW': ' 1X ',
        'TWO_DRAW': ' X2 ',
        'ONE_TWO': ' 12 ',
        'HOME': '1 ',
        'AWAY': '2 ',
        'H1': '1 ',
        'H2': '2 ',
        'HX': 'X ',
      }
    }
  },
  computed: {
    lineStr() {
      let str = this.market_map[this.market] + this.target_map[this.target]
      if (this.pivot) {
        if (this.market === 'EURO_HDP') {
          this.pivot -= 0.5
        }
        str += '(' + (this.pivot) + ') '
      }

      return str
    }
  }
}
</script>

<style scoped>

</style>